import React from "react";

import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import colors from "../../../../../utils/colors";
import AnimatedBurgerIcon from "../../../icons/AnimatedBurgerIcon";
import PredefinedIcon, {
    PredefinedIconType,
} from "../../../icons/Icon/Predefined";
import { Link } from "../../../LinkComponent";
import { ContactFormItemContainer } from "../../index";
import { StyledIconContainer } from "../../Desktop/TopRow/TopLinkItems";

const MobileItems = styled.div`
    z-index: 200;
    display: grid;
    align-items: center;
    justify-content: flex-end;
    grid-auto-flow: column;
    grid-column-gap: 15px;
    color: ${colors.blue};
    font-size: 12px;

    ${({ theme }) => theme.breakpoints.from.normal.css`
        display: none;
    `}
`;

const StyledLink = styled(Link)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;
`;

const BurgerWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
`;

const MobileItemsContainer = ({ handleClick, isActive, nav }) => {
    const theme = useTheme();
    const finderLink = nav.mobileLinks.find((l) =>
        l.name.toLowerCase().includes("finder")
    );

    return (
        <MobileItems>
            {finderLink && (
                <StyledLink to={finderLink.href} title={finderLink.name}>
                    <StyledIconContainer>
                        <PredefinedIcon
                            type={PredefinedIconType.ziel}
                            color={theme.colors.blue.toString()}
                        />
                    </StyledIconContainer>
                    <span>Finder</span>
                </StyledLink>
            )}

            <ContactFormItemContainer />

            <BurgerWrapper>
                <AnimatedBurgerIcon
                    isActive={isActive}
                    handleClick={handleClick}
                />
                <span>Menü</span>
            </BurgerWrapper>
        </MobileItems>
    );
};

export default MobileItemsContainer;
